var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1393_2953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 16C32.5 7.16347 25.3366 3.62396e-05 16.5 3.62396e-05C7.66344 3.62396e-05 0.5 7.16347 0.5 16C0.5 23.9861 6.35097 30.6053 14 31.8057V20.625H9.9375V16H14V12.475C14 8.46504 16.3887 6.25004 20.0434 6.25004C21.794 6.25004 23.625 6.56254 23.625 6.56254V10.5H21.6074C19.6198 10.5 19 11.7334 19 12.9987V16H23.4375L22.7281 20.625H19V31.8057C26.649 30.6053 32.5 23.9861 32.5 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7281 20.625L23.4375 16H19V12.9987C19 11.7333 19.6198 10.5 21.6074 10.5H23.625V6.5625C23.625 6.5625 21.794 6.25 20.0434 6.25C16.3887 6.25 14 8.465 14 12.475V16H9.9375V20.625H14V31.8056C14.8146 31.9334 15.6495 32 16.5 32C17.3505 32 18.1854 31.9334 19 31.8056V20.625H22.7281Z",
    fill: "#13121D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1393_2953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.76a632d46b8d5b36bd3d95f41d9710ac.svg";
export { ForwardRef as ReactComponent };